import React, { useEffect, useState } from "react";

import { Grid, Paper } from "@material-ui/core";

import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";

const detailURL = "/configuration/get-config/";

const MobileNumberChangeSetting = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [mobileNumberChange, setMobileNumberChange] = useState(null);
  const setNotify = useNotifyContext();
  const initialValues = {
    mobile_number_change: mobileNumberChange ? mobileNumberChange : "",
  };

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          if (response.data.mobile_number_change) {
            setMobileNumberChange("option1");
            setLoading(false);
          } else {
            setMobileNumberChange("option2");
            setLoading(false);
          }
        } else {
          console.log("error occured.");
        }
      })
      .catch((error) => {
        if (error.response) {
          setLoading(false);
          console.log(error.response);
        }
      });
  };
  const formButtons = [
    {
      type: "submit",
      label: t("Save"),
      color: "primary",
      saveIcon: <SaveIcon />,
    },
  ];
  const validationSchema = Yup.object({
    mobile_number_change: Yup.string().required("Choose one option"),
  });

  const radioStyle = {
    marginLeft: "1.9%",
    width: "36%",
    marginBottom: "10px",
    marginTop: "4px",
  };

  const handleChange = (event) => {
    let target = event.target;
    let value = target.value;
    setMobileNumberChange(value);
  };

  useEffect(() => {
    fetchDetails();
  }, []);
  const handleSubmit = (values, { setSubmitting }) => {
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, {
        mobile_number_change: mobileNumberChange,
      })
      .then(() => {
        setNotify({
          isOpen: true,
          message: "Successfully saved!",
          type: "success",
        });
        setSubmitting(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
      });
  };

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Grid>
      <Paper
        className={classes.filterPaper}
        variant="outlined"
        style={{ backgroundColor: "#dedede" }}
      >
        {t("Mobile Number Change Configuration")} <br />
      </Paper>
      <Paper className={classes.filterPaper} variant="outlined">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <FormikForm>
                <Grid
                  container
                  className={classes.formContainer}
                  direction="row"
                  spacing={2}
                >
                  <Grid item>
                    <label>
                      <input
                        type="radio"
                        name="mobile_number_change"
                        value="option1"
                        checked={mobileNumberChange === "option1"}
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          marginLeft: 3,
                        }}
                      >
                        Option 1: {t("Yes")}
                      </span>
                      <div style={radioStyle}>
                        {t(
                          "Mobile App User is allowed to request for changing the mobile number via mobile app. Require BO checker to approve before the new value is reflected/modified in user profile."
                        )}
                      </div>
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="mobile_number_change"
                        value="option2"
                        checked={mobileNumberChange === "option2"}
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          marginLeft: 3,
                        }}
                      >
                        Option 2: {t("No")}
                      </span>
                      <div style={radioStyle}>
                        {t(
                          "Mobile app user is not allowed to change mobile number by requesting through mobile app. The changes need to be performed at BackOffice screen. No approval is required once the change is done via BackOffice."
                        )}
                      </div>
                    </label>
                  </Grid>
                </Grid>
                <Grid container justify="flex-start" spacing={3}>
                  {formButtons.map((formButton, index) => {
                    return (
                      <Grid key={index} item xs={12} sm={6} md={4} lg={1}>
                        <Button
                          style={{ textTransform: "capitalize" }}
                          type={formButton.type}
                          variant="contained"
                          color={formButton.color}
                          disabled={formik.isSubmitting}
                          startIcon={<SaveIcon />}
                          fullWidth
                        >
                          {formButton.label}
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              </FormikForm>
            );
          }}
        </Formik>
      </Paper>
    </Grid>
  );
};

export default MobileNumberChangeSetting;
